import React from "react";
import { DashboardCardProps } from "./types";
import "./dashboardCard.scss";
import PercentageDoughnut from "component/Charts/PercentageDoughnut/PercentageDoughnut";
import classNames from "classnames";

export const DashboardCard = ({
  url,
  title,
  testId,
  count,
  type = "count",
  total,
}: DashboardCardProps) => {
  return (
    <div
      data-testId={testId}
      onClick={() => {
        url && window.open(url);
      }}
      className={classNames("dashboard-card", {
        clickable: url,
      })}
    >
      {type === "precentage" ? (
        <div className="percentage-card-content">
          <div className="card-text-content">
            <p className="card-title" data-testId={`${testId}-title`}>
              {title}
            </p>
            <p className="card-value" data-testId={`${testId}-value`}>
              {total ? `${count}/${total}` : "0"}
            </p>
          </div>
          <PercentageDoughnut
            color="#0098ff"
            size="small"
            completed={total ? Math.round((count * 100) / total!) : 0}
            testId={`${testId}-chart`}
          />
        </div>
      ) : (
        <div className="count-card-content card-text-content">
          <p className="card-title" data-testId={`${testId}-title`}>
            {title}
          </p>
          <p className="card-value" data-testId={`${testId}-value`}>
            {count}
          </p>
        </div>
      )}
    </div>
  );
};
